const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

const TabInfo = require('./TabInfo');
const TabAssets = require('./TabAssets');
const TabProfitability = require('./TabProfitability');
const TabFees = require('./TabFees');
const {
    getProfitabilityData,
} = require('../../selectors/fundDataSelectors');


const SelectedTab = ({ fund, index, profitabilityData, catalogueDetails }) => {

    switch (index) {
        case(0): return <TabInfo fund={fund} />;
        case(1): return <TabAssets fund={fund} />;
        case(2): return !!profitabilityData ? <TabProfitability fund={fund} /> : <TabFees fund={fund} catalogueDetails={catalogueDetails}/>;
        case(3): return <TabFees fund={fund} catalogueDetails={catalogueDetails}/>;
        default: return <TabInfo fund={fund} />
    }
};


SelectedTab.propTypes = {
    fund: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    profitabilityData: PropTypes.array,
    catalogueDetails: PropTypes.object
};

const mapStateToProps = (state, props) => ({
    index: state.brokerInvestmentFundView.selectedTab,
    profitabilityData: getProfitabilityData(state, props),
});


module.exports = connect(mapStateToProps)(SelectedTab);
